//
//
//
//
//
//
//
//
//
//
//
//
//

import uParse from '@/components/gaoyia-parse/parse.vue'
export default {
  data() {
    return {
      id: '',
      detail: {},
      loading: false,
	  image:{
		  '飞机':require('@/static/traffic/plane.png'),
		  '火车':require('@/static/traffic/train.png'),
		  '公交车':require('@/static/traffic/transit.png'),
		  '自驾游':require('@/static/traffic/self.png'),
		  '巴士':require('@/static/traffic/bus.png'),
	  }
    }
  },
  components: {
    uParse
  },
  onLoad(event) {
    this.id = event.id
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/cms/touristtraffic/queryById',
        data: {
          id: this.id
        }
      })
        .then(result => {
          this.loading = false
          this.detail = result.data
        }).catch(result => {

        })
    }
  }
}
